export default __webpack_public_path__ + "static/media/Group 15.f92fa573.png";